<template>
  <div class="CustomMenu">
    <el-form ref="form" style="height: 80%" :model="form">
      <el-form-item style="margin-top: 20px">
        <el-radio-group
          v-model="form.typeFiltering"
          @change="getAssetTreeByParameter"
          size="small"
        >
          <el-radio-button label="区域位置">区域</el-radio-button>
          <el-radio-button label="单位部门">部门</el-radio-button>
          <el-radio-button label="分项系统">系统</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="typeValue" @change="changeType">
          <el-radio label="EC_">用电量</el-radio>
          <el-radio label="custom">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="typeValue == 'custom'">
        <el-select
          v-model="value"
          placeholder="请选择"
          size="mini"
          @change="getAssetTreeByParameter"
        >
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox
          v-model="cascade"
          border
          size="mini"
          @change="changeCascade"
          >级联选择</el-checkbox
        >
        <!-- <el-checkbox v-model="selectAll">全选</el-checkbox> -->
      </el-form-item>
      <div style="width: 100%; height: 60%; margin: 10px 0 20px 0">
        <el-tree
          :data="treeData"
          :props="defaultProps"
          node-key="id"
          highlight-current
          accordion
          show-checkbox
          :check-strictly="!cascade"
          :default-expanded-keys="defaultKeys"
          ref="tree"
          style="
            overflow: auto;
            background: #f7f7f7;
            border: 1px solid #e7e7e7;
            border-radius: 6px;
            padding: 20px 0 30px;
            margin-top: 10px;
            height: 100%;
          "
        >
        </el-tree>
      </div>
    </el-form>
    <div style="width: 100%; text-align: center; padding-top: 20px">
      <el-button
        type="primary"
        size="small"
        style="width: 60%"
        @click="changeBtn"
        >添加</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      typeValue: "EC_",
      options: [],
      value: "",
      cascade: false,
      selectAll: false,
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      form: {
        typeFiltering: "区域位置",
      },
      treeAllData: [], //全部树数据
      defaultKeys: [], //默认打开
    };
  },
  methods: {
    changeType() {
      if (this.typeValue == "custom") {
        this.value = this.options[0].key;
      }
      this.getAssetTreeByParameter();
    },
    changeCascade() {
      this.$refs.tree.setCheckedKeys([]);
    },

    // 树选择
    changeBtn() {
      // console.log("key", this.$refs.tree.getCheckedKeys(this.cascade));
      // console.log("node", this.$refs.tree.getCheckedNodes(this.cascade));
      let arr = this.$refs.tree.getCheckedNodes(this.cascade);
      // if (arr.length > 10) {
      //   this.$message.error("最多可选择10条");
      // } else 
      if (arr.length > 0) {
        this.$emit("changeMenu", {
          treeValue: arr,
          typeKey: this.typeValue == "EC_" ? this.typeValue : this.value,
        });
      } else {
        this.$message.error("未选择资产！");
      }
    },

    async getAssetTreeByParameter() {
      this.$store.commit("SET_LOADING", true);
      this.treeData = [];
      let key = this.typeValue == "EC_" ? this.typeValue : this.value;
      if (!key) {
        this.$message.error("请选择自定义属性!");
        this.$store.commit("SET_LOADING", false);
        return;
      }
      let res = await api.getAssetTreeByParameter({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        option: "HasEUDevice",
        maxLevel: 4,
        key: key,
        assetType: this.form.typeFiltering,
      });
      if (res && res.status == 200) {
        if (res.data) {
          this.treeData.push(res.data);
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey();
            this.defaultKeys = [];
            this.defaultKeys.push(this.treeData[0].id);
          });
        }
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
  created() {
    this.$store
      .dispatch("handleParameterKey", {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      })
      .then((res) => {
        this.options = res;
      });
    this.getAssetTreeByParameter();
  },
};
</script>

<style lang="scss" scoped>
.CustomMenu {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  ::v-deep .el-form-item__content {
    margin-left: 30px !important;
  }
  ::v-deep .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
